var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8168 7.03816C17.8018 6.93581 17.7861 6.83295 17.7514 6.73551L17.0852 4.86572C16.9615 4.51835 16.919 4.13625 17.0723 3.80051C17.3948 3.09402 18.3925 2.63474 19.5799 3.38423C20.0514 3.68189 20.2636 4.23644 20.2636 4.7884L20.1086 5.69496C20.013 6.25382 20.1687 6.8209 20.4773 7.29649C21.4412 8.78169 22 10.547 22 12.4409C22 17.7203 17.6582 22 12.3024 22C10.2551 22 8.35596 21.3746 6.79087 20.3071C5.61474 19.5049 6.78899 17.9751 8.21924 17.9751C13.5751 17.9751 17.9168 13.6954 17.9168 8.416C17.9168 7.94811 17.8827 7.48806 17.8168 7.03816Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3388 9.28291C16.3729 8.96914 16.175 8.59039 15.9082 8.75899C15.8495 8.79608 15.7993 8.84868 15.7649 8.91528C13.6065 13.0898 8.98132 15.2367 4.36365 13.6329C3.01469 13.1644 1.39143 14.2225 2.23026 15.3644C3.01516 16.433 4.02957 17.3494 5.23399 18.0325C5.24004 18.0233 5.24613 18.0141 5.25224 18.005C5.85733 17.1072 6.98405 16.4657 8.21923 16.4657C12.4323 16.4657 15.9001 13.321 16.3388 9.28291Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanana);
export default __webpack_public_path__ + "static/media/banana.42d7bebd2f1da4fd3acfe8aab97a8af5.svg";
export { ForwardRef as ReactComponent };